import { useEffect, useState } from "react";
import styles from "../../../ProductsDetails.module.css";
import { useTranslation } from "react-i18next";
import AnimatedDetailsText from "../../../AnimatedDetailsText";
// import ModelSlider from "../../../ModelSlider";

function CoSensor() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [imagesLoaded, setImagesLoaded] = useState({});

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleImageLoad = (index) => {
    setImagesLoaded((prevState) => ({
      ...prevState,
      [index]: true,
    }));
  };
  const { t } = useTranslation();
  const imageData = [
    {
      img: isSmallScreen ? "01.jpg" : "01.jpg",
      title: "",
      subtitle: t(`beeCoSensor.subtitle1`),
      top: isSmallScreen ? "70%" : "40%",
      left: isSmallScreen ? "50%" : "65%",
      textAlign: isSmallScreen ? "center" : "right",
      width: isSmallScreen ? "55%" : "35%",
      direction: isSmallScreen ? "up" : "down",
      zoom: true,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      img: isSmallScreen ? "02.jpg" : "02.jpg",
      title: "",
      subtitle: t(`beeCoSensor.subtitle2`),

      top: isSmallScreen ? "75%" : "40%",
      left: isSmallScreen ? "50%" : "23%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "60%" : "25%",
      direction: isSmallScreen ? "up" : "down",
      //zoom: true,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      img: isSmallScreen ? "03.jpg" : "03.jpg",
      title: t(`beeCoSensor.title3`),
      subtitle: t(`beeCoSensor.subtitle3`),
      top: isSmallScreen ? "13%" : "50%",
      left: isSmallScreen ? "50%" : "75%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "55%" : "25%",
      direction: isSmallScreen ? "up" : "down",
      //zoom: true,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      img: isSmallScreen ? "04.jpg" : "04.jpg",
      title: t(`beeCoSensor.title4`),
      subtitle: t(`beeCoSensor.subtitle4`),
      top: isSmallScreen ? "82%" : "40%",
      left: isSmallScreen ? "50%" : "30%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "80%" : "35%",
      direction: isSmallScreen ? "up" : "down",
      //zoom: true,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      img: isSmallScreen ? "05.jpg" : "05.jpg",
      title: "",
      subtitle: t(`beeCoSensor.subtitle5`),

      top: isSmallScreen ? "80%" : "40%",
      left: isSmallScreen ? "50%" : "75%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "60%" : "30%",
      direction: isSmallScreen ? "up" : "down",
      //zoom: true,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      img: isSmallScreen ? "06.jpg" : "06.jpg",
      title: t(`beeCoSensor.title6`),
      subtitle: t(`beeCoSensor.subtitle6`),
      top: isSmallScreen ? "20%" : "50%",
      left: isSmallScreen ? "50%" : "27%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "75%" : "25%",
      direction: isSmallScreen ? "up" : "down",
      //zoom: true,
      color: isSmallScreen ? "#fff" : "#fff",
    },
    {
      img: isSmallScreen ? "07.jpg" : "07.jpg",
      title: t(`beeCoSensor.title7`),
      subtitle: t(`beeCoSensor.subtitle7`),
      top: isSmallScreen ? "83%" : "35%",
      left: isSmallScreen ? "50%" : "80%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "75%" : "25%",
      direction: isSmallScreen ? "up" : "down",
      //zoom: true,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      img: isSmallScreen ? "08.jpg" : "08.jpg",
      title: t(`beeCoSensor.title8`),
      subtitle: t(`beeCoSensor.subtitle8`),
      top: isSmallScreen ? "75%" : "50%",
      left: isSmallScreen ? "50%" : "22%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "75%" : "25%",
      direction: isSmallScreen ? "up" : "down",
      //zoom: true,
      color: isSmallScreen ? "#fff" : "#fff",
    },
  ];

  const basePath = `${process.env.PUBLIC_URL}/images/03-tis-bee/security-sensor/details/co-sensor`;
  const smallScreenPath = `${basePath}/smallScreens`;

  // const modelsData = [
  //   {
  //     id: 1,
  //     name: "TIS-IP-INT-OUT-DB10",
  //     image: `${basePath}/models/01.png`,
  //   },
  // ];

  return (
    <div className={styles.container}>
      {imageData.map((item, index) => (
        <div
          key={index}
          className={styles.imgContainer}
          style={{ position: "relative", width: "100vw", display: "block" }}
        >
          {item.isVideo ? (
            <VideoAsGif
              className={styles.videoContainer}
              style={{ width: "100vw" }}
              videoSrc={`${basePath}/${item.img}`}
            />
          ) : (
            <img
              style={{
                width: "100vw",
                marginRight: isSmallScreen ? "0" : "0",
                paddingLeft: isSmallScreen ? "0" : "0",
              }}
              src={
                isSmallScreen
                  ? `${smallScreenPath}/${item.img}`
                  : `${basePath}/${item.img}`
              }
              alt=""
              onLoad={() => handleImageLoad(index)}
            />
          )}
          {imagesLoaded[index] && (
            <div
              style={{
                position: "absolute",
                top: item.top,
                left: item.left,
                transform: "translate(-50%, -50%)",
                textAlign: item.textAlign,
                width: item.width,
              }}
            >
              <AnimatedDetailsText
                text={{
                  title: item.title,
                  subtitle: item.subtitle,
                }}
                color={item.color || "#000"}
                textAlign={item.textAlign}
                margin="20px 0"
                padding="10px"
                direction={item.direction}
                fontSize={item.fontSize || "20px"}
                zoom={item.zoom}
              />
            </div>
          )}
          {/* عرض مكون ModelSlider بعد الصورة الأولى فقط */}
          {/* {index === 0 && (
            <div style={{ textAlign: "center" }}>
              <h1 style={{ textAlign: "center", fontSize: "20px",marginTop: "40px" }}>Product Models</h1>
              <div>
                <ModelSlider models={modelsData} />
              </div>
            </div>
          )} */}
        </div>
      ))}
    </div>
  );
}

export default CoSensor;

const VideoAsGif = ({ videoSrc, className }) => {
  return (
    <div className={styles.videoContainer}>
      <video
        className={styles.fullscreenVideo}
        autoPlay
        muted
        loop
        playsInline // مهم لأجهزة iPhone
        disablePictureInPicture // منع خاصية "صورة داخل صورة"
        controls={false} // إخفاء أزرار التحكم
        style={{ display: "block", width: "100%" }}
      >
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};
